<div class="main-layout">
    <app-header></app-header>
    <div class="main-container">
        <router-outlet />
    </div>
</div>